module.exports = __webpack_public_path__ + "static/img/equip-4.f0928901.png";